// extracted by mini-css-extract-plugin
module.exports = {"Grid":"GiftCardList_Grid__1sfyk","Row":"GiftCardList_Row__1m8He","Column":"GiftCardList_Column__KxeEk"};